export const createPaletteOptions = (tokens) => {
    const { core: { color: { gray, green, blue, yellow, purple, red }, }, semantic: { color: { action, background, type, ui, status }, }, } = tokens;
    const palette = {
        common: {
            black: gray[1000].value,
            white: gray[0].value,
        },
        grey: {
            100: gray[100].value,
            200: gray[200].value,
            300: gray[300].value,
            400: gray[400].value,
            500: gray[500].value,
            600: gray[600].value,
            700: gray[700].value,
            800: gray[800].value,
            900: gray[900].value,
            950: gray[950].value,
        },
        green: {
            0: green[0].value,
            10: green[10].value,
            20: green[20].value,
            25: green[25].value,
            30: green[30].value,
            35: green[35].value,
            40: green[40].value,
            50: green[50].value,
            60: green[60].value,
            70: green[70].value,
            80: green[80].value,
            90: green[90].value,
            95: green[95].value,
            98: green[98].value,
            99: green[99].value,
            100: green[100].value,
        },
        blue: {
            0: blue[0].value,
            10: blue[10].value,
            20: blue[20].value,
            25: blue[25].value,
            30: blue[30].value,
            35: blue[35].value,
            40: blue[40].value,
            50: blue[50].value,
            60: blue[60].value,
            70: blue[70].value,
            80: blue[80].value,
            90: blue[90].value,
            95: blue[95].value,
            98: blue[98].value,
            99: blue[99].value,
            100: blue[100].value,
        },
        yellow: {
            0: yellow[0].value,
            10: yellow[10].value,
            20: yellow[20].value,
            25: yellow[25].value,
            30: yellow[30].value,
            35: yellow[35].value,
            40: yellow[40].value,
            50: yellow[50].value,
            60: yellow[60].value,
            70: yellow[70].value,
            80: yellow[80].value,
            90: yellow[90].value,
            95: yellow[95].value,
            98: yellow[98].value,
            99: yellow[99].value,
            100: yellow[100].value,
        },
        purple: {
            0: purple[0].value,
            10: purple[10].value,
            20: purple[20].value,
            25: purple[25].value,
            30: purple[30].value,
            35: purple[35].value,
            40: purple[40].value,
            50: purple[50].value,
            60: purple[60].value,
            70: purple[70].value,
            80: purple[80].value,
            90: purple[90].value,
            95: purple[95].value,
            98: purple[98].value,
            99: purple[99].value,
            100: purple[100].value,
        },
        red: {
            0: red[0].value,
            10: red[10].value,
            20: red[20].value,
            25: red[25].value,
            30: red[30].value,
            35: red[35].value,
            40: red[40].value,
            50: red[50].value,
            60: red[60].value,
            70: red[70].value,
            80: red[80].value,
            90: red[90].value,
            95: red[95].value,
            98: red[98].value,
            99: red[99].value,
            100: red[100].value,
        },
        primary: {
            main: action.primary.default.value,
            dark: action.primary.active.value,
            light: action.primary.hover.value,
            contrastText: action.primary.onPrimary.value,
        },
        error: {
            main: status.error.default.value,
            dark: status.error.default.value,
            light: status.error.default.value,
            contrastText: status.error.text.value,
        },
        warning: {
            main: status.warning.default.value,
            dark: status.warning.default.value,
            light: status.warning.default.value,
            contrastText: status.warning.text.value,
        },
        info: {
            main: status.notification.default.value,
            dark: status.notification.default.value,
            light: status.notification.default.value,
            contrastText: status.notification.text.value,
        },
        success: {
            main: status.success.default.value,
            dark: status.success.default.value,
            light: status.success.default.value,
            contrastText: status.success.text.value,
        },
        destructive: {
            main: action.destructive.default.value,
            dark: action.destructive.active.value,
            light: action.destructive.hover.value,
            contrastText: action.destructive.onDestructive.value,
        },
        background: {
            default: background.base.value,
            container: background.container.value,
            navSelection: background.navSelection.value,
        },
        text: {
            primary: type.default.value,
            secondary: type.muted.value,
            disabled: type.disabled.value,
        },
        new: status.new.default.value,
        processing: {
            main: gray[300].value,
            dark: gray[300].value,
            light: gray[300].value,
            contrastText: gray[300].value,
        },
        divider: ui.divider.default.value,
        dividerSecondary: ui.divider.secondary.value,
        action: {
            disabled: type.disabled.value,
            disabledBackground: action.primary.disabled.value,
            disabledOpacity: 1,
            active: action.primary.default.value,
            activatedOpacity: 1,
        },
    };
    return palette;
};
//# sourceMappingURL=palette.js.map